interface KspLinkProps {
  uin: string | number;
}

export default function KspLink({ uin }: KspLinkProps) {
  return (
    <div className="flex w-full flex-auto flex-col md:w-[35%]">
      <a
        rel="noopener noreferrer"
        href={`https://www.ksp.co.il/web/item/${uin}`}
        target="_blank"
        className="flex h-8 items-center justify-center rounded bg-gradient-to-r from-cyan-600 to-violet-600 py-2 text-center text-sm font-semibold tracking-widest text-white hover:from-sky-400 hover:to-emerald-400 md:h-full"
      >
        מעבר לעמוד המוצר ב-KSP
      </a>
    </div>
  );
}
